// This file is AUTOGENERATED, do not edit it manually!!!

import { commonClient as commonClientde } from './commonClientResx.de';
import { commonClient as commonClienten } from './commonClientResx.en';
import { commonClient as commonClienten_risk } from './commonClientResx.en_risk';
import { commonClient as commonClientes } from './commonClientResx.es';
import { commonClient as commonClientfr } from './commonClientResx.fr';
import { commonClient as commonClientit } from './commonClientResx.it';
import { commonClient as commonClientnl } from './commonClientResx.nl';
import { commonClient as commonClientpl } from './commonClientResx.pl';
import { commonClient as commonClientpt } from './commonClientResx.pt';
import { commonClient as commonClientru } from './commonClientResx.ru';
import { commonClient as commonClientsk } from './commonClientResx.sk';
import { commonClient as commonClientsv } from './commonClientResx.sv';
import { commonClient as commonClienttr } from './commonClientResx.tr';

const langMap: { [k: string]: Partial<typeof commonClienten> } = {
    de: commonClientde,
    en: commonClienten,
    en_risk: commonClienten_risk,
    es: commonClientes,
    fr: commonClientfr,
    it: commonClientit,
    nl: commonClientnl,
    pl: commonClientpl,
    pt: commonClientpt,
    ru: commonClientru,
    sk: commonClientsk,
    sv: commonClientsv,
    tr: commonClienttr,
};

/* tslint:disable: max-line-length */
export const commonClientResx = {
    get about_item() {
        return langMap[ep.resxCulture].about_item || langMap.en.about_item;
    },
    get add() {
        return langMap[ep.resxCulture].add || langMap.en.add;
    },
    get AddMoreSpace() {
        return langMap[ep.resxCulture].AddMoreSpace || langMap.en.AddMoreSpace;
    },
    get all_projects_label() {
        return langMap[ep.resxCulture].all_projects_label || langMap.en.all_projects_label;
    },
    get archive_action_text() {
        return langMap[ep.resxCulture].archive_action_text || langMap.en.archive_action_text;
    },
    get archive_date_label() {
        return langMap[ep.resxCulture].archive_date_label || langMap.en.archive_date_label;
    },
    get archived_by_label() {
        return langMap[ep.resxCulture].archived_by_label || langMap.en.archived_by_label;
    },
    get Attach() {
        return langMap[ep.resxCulture].Attach || langMap.en.Attach;
    },
    get attach_file_image() {
        return langMap[ep.resxCulture].attach_file_image || langMap.en.attach_file_image;
    },
    get automation_purchase_notes() {
        return langMap[ep.resxCulture].automation_purchase_notes || langMap.en.automation_purchase_notes;
    },
    get automation_trial_description_end() {
        return langMap[ep.resxCulture].automation_trial_description_end || langMap.en.automation_trial_description_end;
    },
    get automation_trial_description_middle() {
        return langMap[ep.resxCulture].automation_trial_description_middle || langMap.en.automation_trial_description_middle;
    },
    get automation_trial_description_start() {
        return langMap[ep.resxCulture].automation_trial_description_start || langMap.en.automation_trial_description_start;
    },
    get automation_trial_expired() {
        return langMap[ep.resxCulture].automation_trial_expired || langMap.en.automation_trial_expired;
    },
    get automation_trial_expired_notes() {
        return langMap[ep.resxCulture].automation_trial_expired_notes || langMap.en.automation_trial_expired_notes;
    },
    get btn_reload() {
        return langMap[ep.resxCulture].btn_reload || langMap.en.btn_reload;
    },
    get buy_subscription() {
        return langMap[ep.resxCulture].buy_subscription || langMap.en.buy_subscription;
    },
    get Cancel() {
        return langMap[ep.resxCulture].Cancel || langMap.en.Cancel;
    },
    get change() {
        return langMap[ep.resxCulture].change || langMap.en.change;
    },
    get checkbox_list_text() {
        return langMap[ep.resxCulture].checkbox_list_text || langMap.en.checkbox_list_text;
    },
    get Close() {
        return langMap[ep.resxCulture].Close || langMap.en.Close;
    },
    get completeActivityConfirm() {
        return langMap[ep.resxCulture].completeActivityConfirm || langMap.en.completeActivityConfirm;
    },
    get completeActivityTitle() {
        return langMap[ep.resxCulture].completeActivityTitle || langMap.en.completeActivityTitle;
    },
    get completeProjectConfirm() {
        return langMap[ep.resxCulture].completeProjectConfirm || langMap.en.completeProjectConfirm;
    },
    get completeProjectTitle() {
        return langMap[ep.resxCulture].completeProjectTitle || langMap.en.completeProjectTitle;
    },
    get confirmCompleteActivityParents() {
        return langMap[ep.resxCulture].confirmCompleteActivityParents || langMap.en.confirmCompleteActivityParents;
    },
    get confirmCompleteActivityParentsTitle() {
        return langMap[ep.resxCulture].confirmCompleteActivityParentsTitle || langMap.en.confirmCompleteActivityParentsTitle;
    },
    get contact_us() {
        return langMap[ep.resxCulture].contact_us || langMap.en.contact_us;
    },
    get continue() {
        return langMap[ep.resxCulture].continue || langMap.en.continue;
    },
    get copied_label() {
        return langMap[ep.resxCulture].copied_label || langMap.en.copied_label;
    },
    get copy_link_feedback() {
        return langMap[ep.resxCulture].copy_link_feedback || langMap.en.copy_link_feedback;
    },
    get copying_label() {
        return langMap[ep.resxCulture].copying_label || langMap.en.copying_label;
    },
    get copyLink() {
        return langMap[ep.resxCulture].copyLink || langMap.en.copyLink;
    },
    get custom_field_label() {
        return langMap[ep.resxCulture].custom_field_label || langMap.en.custom_field_label;
    },
    get custom_form_label() {
        return langMap[ep.resxCulture].custom_form_label || langMap.en.custom_form_label;
    },
    get date_text() {
        return langMap[ep.resxCulture].date_text || langMap.en.date_text;
    },
    get DayAbbreviation() {
        return langMap[ep.resxCulture].DayAbbreviation || langMap.en.DayAbbreviation;
    },
    get DayPluralFormat() {
        return langMap[ep.resxCulture].DayPluralFormat || langMap.en.DayPluralFormat;
    },
    get DayPluralFormatTemplate() {
        return langMap[ep.resxCulture].DayPluralFormatTemplate || langMap.en.DayPluralFormatTemplate;
    },
    get Delete() {
        return langMap[ep.resxCulture].Delete || langMap.en.Delete;
    },
    get delete_confirmation() {
        return langMap[ep.resxCulture].delete_confirmation || langMap.en.delete_confirmation;
    },
    get delete_permanently_text() {
        return langMap[ep.resxCulture].delete_permanently_text || langMap.en.delete_permanently_text;
    },
    get description_information() {
        return langMap[ep.resxCulture].description_information || langMap.en.description_information;
    },
    get disabled() {
        return langMap[ep.resxCulture].disabled || langMap.en.disabled;
    },
    get disabledUserText() {
        return langMap[ep.resxCulture].disabledUserText || langMap.en.disabledUserText;
    },
    get Download() {
        return langMap[ep.resxCulture].Download || langMap.en.Download;
    },
    get dropdown_text() {
        return langMap[ep.resxCulture].dropdown_text || langMap.en.dropdown_text;
    },
    get Duplicate() {
        return langMap[ep.resxCulture].Duplicate || langMap.en.Duplicate;
    },
    get Edit() {
        return langMap[ep.resxCulture].Edit || langMap.en.Edit;
    },
    get ElapsedTime_Ago() {
        return langMap[ep.resxCulture].ElapsedTime_Ago || langMap.en.ElapsedTime_Ago;
    },
    get enabled() {
        return langMap[ep.resxCulture].enabled || langMap.en.enabled;
    },
    get Entity_Category() {
        return langMap[ep.resxCulture].Entity_Category || langMap.en.Entity_Category;
    },
    get Entity_Customer() {
        return langMap[ep.resxCulture].Entity_Customer || langMap.en.Entity_Customer;
    },
    get Entity_Invoice() {
        return langMap[ep.resxCulture].Entity_Invoice || langMap.en.Entity_Invoice;
    },
    get Entity_Issue() {
        return langMap[ep.resxCulture].Entity_Issue || langMap.en.Entity_Issue;
    },
    get Entity_JobRole() {
        return langMap[ep.resxCulture].Entity_JobRole || langMap.en.Entity_JobRole;
    },
    get Entity_OAuthAccountClient() {
        return langMap[ep.resxCulture].Entity_OAuthAccountClient || langMap.en.Entity_OAuthAccountClient;
    },
    get Entity_Portfolio() {
        return langMap[ep.resxCulture].Entity_Portfolio || langMap.en.Entity_Portfolio;
    },
    get Entity_Priority() {
        return langMap[ep.resxCulture].Entity_Priority || langMap.en.Entity_Priority;
    },
    get Entity_Project() {
        return langMap[ep.resxCulture].Entity_Project || langMap.en.Entity_Project;
    },
    get Entity_ProjectStatus() {
        return langMap[ep.resxCulture].Entity_ProjectStatus || langMap.en.Entity_ProjectStatus;
    },
    get Entity_Request() {
        return langMap[ep.resxCulture].Entity_Request || langMap.en.Entity_Request;
    },
    get Entity_Task() {
        return langMap[ep.resxCulture].Entity_Task || langMap.en.Entity_Task;
    },
    get Entity_TaskStatus() {
        return langMap[ep.resxCulture].Entity_TaskStatus || langMap.en.Entity_TaskStatus;
    },
    get Entity_User() {
        return langMap[ep.resxCulture].Entity_User || langMap.en.Entity_User;
    },
    get Error_CantFindObjectTemplate() {
        return langMap[ep.resxCulture].Error_CantFindObjectTemplate || langMap.en.Error_CantFindObjectTemplate;
    },
    get error_notFullyCompleted() {
        return langMap[ep.resxCulture].error_notFullyCompleted || langMap.en.error_notFullyCompleted;
    },
    get ErrorFileSizeLimit() {
        return langMap[ep.resxCulture].ErrorFileSizeLimit || langMap.en.ErrorFileSizeLimit;
    },
    get ErrorUploadExceededText() {
        return langMap[ep.resxCulture].ErrorUploadExceededText || langMap.en.ErrorUploadExceededText;
    },
    get ErrorUploadText() {
        return langMap[ep.resxCulture].ErrorUploadText || langMap.en.ErrorUploadText;
    },
    get ErrorUploadTitle() {
        return langMap[ep.resxCulture].ErrorUploadTitle || langMap.en.ErrorUploadTitle;
    },
    get ErrorVirusText() {
        return langMap[ep.resxCulture].ErrorVirusText || langMap.en.ErrorVirusText;
    },
    get ErrorVirusTitle() {
        return langMap[ep.resxCulture].ErrorVirusTitle || langMap.en.ErrorVirusTitle;
    },
    get exported() {
        return langMap[ep.resxCulture].exported || langMap.en.exported;
    },
    get exporting() {
        return langMap[ep.resxCulture].exporting || langMap.en.exporting;
    },
    get failed() {
        return langMap[ep.resxCulture].failed || langMap.en.failed;
    },
    get help() {
        return langMap[ep.resxCulture].help || langMap.en.help;
    },
    get HourAbbreviation() {
        return langMap[ep.resxCulture].HourAbbreviation || langMap.en.HourAbbreviation;
    },
    get HourPluralFormat() {
        return langMap[ep.resxCulture].HourPluralFormat || langMap.en.HourPluralFormat;
    },
    get HourPluralFormatTemplate() {
        return langMap[ep.resxCulture].HourPluralFormatTemplate || langMap.en.HourPluralFormatTemplate;
    },
    get HyperLinkTooltip() {
        return langMap[ep.resxCulture].HyperLinkTooltip || langMap.en.HyperLinkTooltip;
    },
    get items_selected_plural() {
        return langMap[ep.resxCulture].items_selected_plural || langMap.en.items_selected_plural;
    },
    get madeBy() {
        return langMap[ep.resxCulture].madeBy || langMap.en.madeBy;
    },
    get MinuteAbbreviation() {
        return langMap[ep.resxCulture].MinuteAbbreviation || langMap.en.MinuteAbbreviation;
    },
    get MinutePluralFormat() {
        return langMap[ep.resxCulture].MinutePluralFormat || langMap.en.MinutePluralFormat;
    },
    get more_counter_text() {
        return langMap[ep.resxCulture].more_counter_text || langMap.en.more_counter_text;
    },
    get next() {
        return langMap[ep.resxCulture].next || langMap.en.next;
    },
    get no_items_selected() {
        return langMap[ep.resxCulture].no_items_selected || langMap.en.no_items_selected;
    },
    get None_Text() {
        return langMap[ep.resxCulture].None_Text || langMap.en.None_Text;
    },
    get Not_set() {
        return langMap[ep.resxCulture].Not_set || langMap.en.Not_set;
    },
    get Ok() {
        return langMap[ep.resxCulture].Ok || langMap.en.Ok;
    },
    get one_after_another_label() {
        return langMap[ep.resxCulture].one_after_another_label || langMap.en.one_after_another_label;
    },
    get one_after_another_tooltip() {
        return langMap[ep.resxCulture].one_after_another_tooltip || langMap.en.one_after_another_tooltip;
    },
    get open_details_new_tab() {
        return langMap[ep.resxCulture].open_details_new_tab || langMap.en.open_details_new_tab;
    },
    get open_in_new_tab() {
        return langMap[ep.resxCulture].open_in_new_tab || langMap.en.open_in_new_tab;
    },
    get OpeningWindow() {
        return langMap[ep.resxCulture].OpeningWindow || langMap.en.OpeningWindow;
    },
    get OpenOriginal() {
        return langMap[ep.resxCulture].OpenOriginal || langMap.en.OpenOriginal;
    },
    get OperationError_Title() {
        return langMap[ep.resxCulture].OperationError_Title || langMap.en.OperationError_Title;
    },
    get paragraph_text() {
        return langMap[ep.resxCulture].paragraph_text || langMap.en.paragraph_text;
    },
    get parentActivity() {
        return langMap[ep.resxCulture].parentActivity || langMap.en.parentActivity;
    },
    get PerDay() {
        return langMap[ep.resxCulture].PerDay || langMap.en.PerDay;
    },
    get PerWeek() {
        return langMap[ep.resxCulture].PerWeek || langMap.en.PerWeek;
    },
    get project_custom_fields_label() {
        return langMap[ep.resxCulture].project_custom_fields_label || langMap.en.project_custom_fields_label;
    },
    get Remove() {
        return langMap[ep.resxCulture].Remove || langMap.en.Remove;
    },
    get request_has_been_sent_successfully() {
        return langMap[ep.resxCulture].request_has_been_sent_successfully || langMap.en.request_has_been_sent_successfully;
    },
    get Request_Trial() {
        return langMap[ep.resxCulture].Request_Trial || langMap.en.Request_Trial;
    },
    get Reset() {
        return langMap[ep.resxCulture].Reset || langMap.en.Reset;
    },
    get Save() {
        return langMap[ep.resxCulture].Save || langMap.en.Save;
    },
    get saved() {
        return langMap[ep.resxCulture].saved || langMap.en.saved;
    },
    get saving() {
        return langMap[ep.resxCulture].saving || langMap.en.saving;
    },
    get Search() {
        return langMap[ep.resxCulture].Search || langMap.en.Search;
    },
    get select_placeholder() {
        return langMap[ep.resxCulture].select_placeholder || langMap.en.select_placeholder;
    },
    get selection_mode_text() {
        return langMap[ep.resxCulture].selection_mode_text || langMap.en.selection_mode_text;
    },
    get sending() {
        return langMap[ep.resxCulture].sending || langMap.en.sending;
    },
    get setCompleted() {
        return langMap[ep.resxCulture].setCompleted || langMap.en.setCompleted;
    },
    get show_less_label() {
        return langMap[ep.resxCulture].show_less_label || langMap.en.show_less_label;
    },
    get show_more_label() {
        return langMap[ep.resxCulture].show_more_label || langMap.en.show_more_label;
    },
    get space_exceeded_description() {
        return langMap[ep.resxCulture].space_exceeded_description || langMap.en.space_exceeded_description;
    },
    get space_exceeded_title() {
        return langMap[ep.resxCulture].space_exceeded_title || langMap.en.space_exceeded_title;
    },
    get submit() {
        return langMap[ep.resxCulture].submit || langMap.en.submit;
    },
    get subscribe_trouble_description() {
        return langMap[ep.resxCulture].subscribe_trouble_description || langMap.en.subscribe_trouble_description;
    },
    get summary() {
        return langMap[ep.resxCulture].summary || langMap.en.summary;
    },
    get time_input_placeholder() {
        return langMap[ep.resxCulture].time_input_placeholder || langMap.en.time_input_placeholder;
    },
    get timer_text() {
        return langMap[ep.resxCulture].timer_text || langMap.en.timer_text;
    },
    get title_notFullyCompleted() {
        return langMap[ep.resxCulture].title_notFullyCompleted || langMap.en.title_notFullyCompleted;
    },
    get title_reload() {
        return langMap[ep.resxCulture].title_reload || langMap.en.title_reload;
    },
    get total() {
        return langMap[ep.resxCulture].total || langMap.en.total;
    },
    get turn_off() {
        return langMap[ep.resxCulture].turn_off || langMap.en.turn_off;
    },
    get type() {
        return langMap[ep.resxCulture].type || langMap.en.type;
    },
    get Type_for_search() {
        return langMap[ep.resxCulture].Type_for_search || langMap.en.Type_for_search;
    },
    get Type_for_search_or_add() {
        return langMap[ep.resxCulture].Type_for_search_or_add || langMap.en.Type_for_search_or_add;
    },
    get Type_for_search_or_create() {
        return langMap[ep.resxCulture].Type_for_search_or_create || langMap.en.Type_for_search_or_create;
    },
    get unarchive_action_text() {
        return langMap[ep.resxCulture].unarchive_action_text || langMap.en.unarchive_action_text;
    },
    get undoing() {
        return langMap[ep.resxCulture].undoing || langMap.en.undoing;
    },
    get undone() {
        return langMap[ep.resxCulture].undone || langMap.en.undone;
    },
    get upload() {
        return langMap[ep.resxCulture].upload || langMap.en.upload;
    },
    get WebPushNotificationPanelLink() {
        return langMap[ep.resxCulture].WebPushNotificationPanelLink || langMap.en.WebPushNotificationPanelLink;
    },
    get WebPushNotificationPanelText() {
        return langMap[ep.resxCulture].WebPushNotificationPanelText || langMap.en.WebPushNotificationPanelText;
    },
    get you_user_text() {
        return langMap[ep.resxCulture].you_user_text || langMap.en.you_user_text;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.commonClient = commonClientResx;
